import { render } from "./RankRewardInfoComponent.vue?vue&type=template&id=63a6cc91"
import script from "./RankRewardInfoComponent.vue?vue&type=script&lang=js"
export * from "./RankRewardInfoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__